<template>
    <svg fill="#48B6E7" height="21" viewBox="0 0 21 21" width="21" xmlns="http://www.w3.org/2000/svg">
        <g fill-rule="nonzero">
            <path
                d="M13.949 6.938H7.348c-.39 0-.707.332-.707.742s.316.742.707.742h6.601c.39 0 .707-.332.707-.742s-.316-.742-.707-.742zM13.949 9.906H7.348c-.39 0-.707.332-.707.742s.316.743.707.743h6.601c.39 0 .707-.333.707-.743s-.316-.742-.707-.742zM13.949 12.578H7.348c-.39 0-.707.332-.707.742s.316.742.707.742h6.601c.39 0 .707-.332.707-.742s-.316-.742-.707-.742z"
            />
            <path
                d="M10.5 1C5.262 1 1 5.188 1 10.335a9.159 9.159 0 0 0 1.978 5.695l-1.295 2.983a.699.699 0 0 0 .098.718.726.726 0 0 0 .69.258l4.906-.841a9.371 9.371 0 0 0 3.123.521c5.238 0 9.5-4.187 9.5-9.334C20 5.188 15.738 1 10.5 1zm0 17.251a7.882 7.882 0 0 1-2.796-.496.73.73 0 0 0-.383-.036l-3.79.65.946-2.18a.7.7 0 0 0-.118-.742 7.686 7.686 0 0 1-1.364-2.227 7.78 7.78 0 0 1-.552-2.885c0-4.366 3.614-7.917 8.057-7.917 4.443 0 8.057 3.551 8.057 7.917 0 4.365-3.614 7.916-8.057 7.916z"
                stroke="#48B6E7"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "ConversationColor",
};
</script>
